import { css } from "@emotion/react";
import { palette } from "@jnpmedi/grebob";

export const globalStyles = css`
  html,
  body {
    font-size: 0.86rem;
    font-family: "Roboto", "Nunito", "Noto Sans KR", sans-serif;

    height: 100%;
    margin: 0;
    padding: 0;
    background-color: ${palette["bg020"]};
    color: ${palette["grey090"]};

    overscroll-behavior-y: none;
  }

  a,
  button,
  span,
  p,
  input,
  em,
  div {
    font-family: "Roboto", "Nunito", "Noto Sans KR", sans-serif;
    -webkit-font-smoothing: auto !important;
  }

  * {
    box-sizing: border-box;
    touch-action: manipulation;
  }

  a {
    color: ${palette["linkText"]};
    text-decoration-skip-ink: none;
  }

  h1 {
    margin: 0.5rem 0;
    font-size: 1.5rem;
  }

  h2 {
    margin: 1rem 0;
    font-size: 1.25rem;
  }

  h3 {
    font-size: 1.125rem;
  }

  h4 {
    font-size: 1rem;
  }

  input {
    appearance: none;

    &:focus {
      box-shadow: none;
      outline: none;
    }

    &:active {
      box-shadow: none;
      outline: none;
    }
  }

  button {
    appearance: none;

    &:focus {
      box-shadow: none;
      outline: none;
    }

    &:active {
      box-shadow: none;
      outline: none;
    }
  }

  #root {
    height: 100%;
  }

  html.noanim {
    * {
      transition: none !important;

      &:after,
      &:before {
        transition: none !important;
      }
    }
  }

  // Surface Global css(styles.scss)과의 충돌로 별도 지정 (24.02.18)
  .MuiSwitch-track {
    box-sizing: content-box;
  }

  /* NOTE: input type: number의 default 화살표 제거 */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
